import { render, staticRenderFns } from "./snailLiveNow.vue?vue&type=template&id=5ab2c457&scoped=true&"
import script from "./snailLiveNow.vue?vue&type=script&lang=js&"
export * from "./snailLiveNow.vue?vue&type=script&lang=js&"
import style0 from "./snailLiveNow.vue?vue&type=style&index=0&id=5ab2c457&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2c457",
  null
  
)

export default component.exports